import {HandlerRegistry} from "./handler-registry.service";
import {Handler} from "./handler";
import {InjectorProvider} from "../injector-provider";

@Handler()
export class StandaloneHandler {

  constructor() {
    this["subscription"] = InjectorProvider.injector.get(HandlerRegistry).registerHandlerInstance(
      this.constructor.name, this);
  }
}
